import {enforce} from "vest";
import isEmail from 'validator/es/lib/isEmail';

enforce.extend({ isEmail });

export function email(value: any) {
  enforce(value).message('validator.email').isEmail();
}
